import {
  Box,
  Card,
  Grid,
  Skeleton,
  Stack,
} from "@mui/material";

const TableSkeleton = () => {
  return (
    <Card sx={{ p: 2, mb: 4 }}>
      {/* Header */}
      <Grid container justifyContent="space-between" alignItems="center" mb={3}>
        <Grid item xs={5}>
          <Skeleton variant="text" width={280} height={35} />
        </Grid>

        <Grid item>
          <Stack direction="row" spacing={2} alignItems="center">
            <Skeleton variant="rounded" width={250} height={38} />
            <Skeleton variant="circular" width={24} height={24} />
          </Stack>
        </Grid>
      </Grid>

      {/* Table Header */}
      <Grid container spacing={2} mb={2}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Grid item xs key={item}>
            <Skeleton variant="text" width="80%" height={25} />
          </Grid>
        ))}
      </Grid>

      {/* Table Rows */}
      {[1, 2].map((row) => (
        <Grid
          container
          spacing={2}
          alignItems="center"
          mb={2}
          key={row}
        >
          {[1, 2, 3, 4, 5].map((cell) => (
            <Grid item xs key={cell}>
              <Skeleton variant="text" width="90%" height={28} />
            </Grid>
          ))}
        </Grid>
      ))}

      {/* Horizontal Scroll */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={10}
        sx={{ my: 2 }}
      />

      {/* Pagination */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Skeleton variant="text" width={120} height={25} />

        <Skeleton variant="rounded" width={140} height={32} />

        <Skeleton variant="text" width={70} height={25} />
      </Grid>
    </Card>
  );
};

export default function AnomaliesSkeleton2() {
  return (
    <Box>
      <TableSkeleton />
      <TableSkeleton />
    </Box>
  );
}